import Vue from 'vue'
import Router from 'vue-router'

import { routersConfig } from './config/routersConfig.js'

Vue.use(Router);

export default new Router({
  // 应用的基路径。例如，如果整个单页应用服务在 /app/ 下，然后 base 就应该设为 "/app/"。
  // 默认值: "router-link-active"
  // 全局配置 <router-link> 的默认『激活 class 类名』
  linkActiveClass: 'router-link-active',
  // 全局配置 <router-link> 精确激活的默认的 class
  linkExactActiveClass: 'router-link-exact-active',
  base: '/',
  // history: false,
  mode: 'history',
  scrollBehavior: function (to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash
      }
    }
    return savedPosition || { x: 0, y: 0 }
  },
  routes: routersConfig
})
